import React from 'react';
import PropTypes from 'prop-types';

import { Col, Grid } from 'bricks';

import ViewFiltersDesktop from './ViewFiltersDesktop';
import ViewFiltersMobile from './ViewFiltersMobile';

/**
 * ViewFilters have different views and even data displayed in mobile and desktop
 * common props are fetched from redux in common view
 */
export default function ViewFiltersLayout({ showButton, className, isMobile }) {
  return (
    <Grid className={className} nowrap>
      <Col>
        {isMobile ?
          <ViewFiltersMobile showButton={showButton} />
        : <ViewFiltersDesktop showButton={showButton} />}
      </Col>
    </Grid>
  );
}

ViewFiltersLayout.propTypes = {
  showButton: PropTypes.bool,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};
